import fetch from '../utils/fetch'

export function saveSetting(query) {
  return fetch({
    url: '/selfhelp/formdata',
    method: 'post',
    params: query
  })
}

export function getSettingList(query) {
  return fetch({
    url: '/selfhelp/formdata',
    method: 'get',
    params: query
  })
}

export function getSettingInfo(id) {
  return fetch({
    url: '/selfhelp/formdata/' + id,
    method: 'get'
  })
}

export function updateSetting(query) {
  return fetch({
    url: '/selfhelp/formdata',
    method: 'put',
    params: query
  })
}

export function deleteSetting(id) {
  return fetch({
    url: '/selfhelp/formdata/discard/' + id,
    method: 'post'
  })
}

export function restoreSetting(id) {
  return fetch({
    url: '/selfhelp/formdata/restore/' + id,
    method: 'post'
  })
}

export function saveTemplate(query) {
  return fetch({
    url: '/selfhelp/formtem',
    method: 'post',
    params: query
  })
}

export function getTemplateList(query) {
  return fetch({
    url: '/selfhelp/formtem',
    method: 'get',
    params: query
  })
}

export function getTemplateInfo(id) {
  return fetch({
    url: '/selfhelp/formtem/' + id,
    method: 'get'
  })
}

export function updateTemplate(query) {
  return fetch({
    url: '/selfhelp/formtem',
    method: 'put',
    params: query
  })
}

export function deleteTemplate(id) {
  return fetch({
    url: '/selfhelp/formtem/discard/' + id,
    method: 'post'
  })
}

export function restoreTemplate(id) {
  return fetch({
    url: '/selfhelp/formtem/restore/' + id,
    method: 'post'
  })
}

export function physicalFirst() {
  return fetch({
    url: '/selfhelp/setting/physical',
    method: 'get'
  })
}

export function physicalNormal(query) {
  return fetch({
    url: '/selfhelp/setting/physical',
    method: 'post',
    params: query
  })
}

export function allUserList(query) {
  return fetch({
    url: '/selfhelp/physical/alluserlist',
    method: 'get',
    params: query
  })
}

export function allUserData(query) {
  return fetch({
    url: '/selfhelp/physical/userdata',
    method: 'get',
    params: query
  })
}

export function timeData(query) {
  return fetch({
    url: '/selfhelp/physical/datelist',
    method: 'get',
    params: query
  })
}

// 活动
export function regActivityList(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/list',
    method: 'get',
    params: query
  })
}

// 活动场次
export function registrationActivitySessionList(query) {
  return fetch({
    url: '/selfhelp/registrationActivitySession/list',
    method: 'get',
    params: query
  })
}
// 活动场次删除
export function registrationActivitySessionDel(query) {
  return fetch({
    url: '/selfhelp/registrationActivitySession/del',
    method: 'get',
    params: query
  })
}
// 场次新增
export function registrationActivitySessionAdd(query) {
  return fetch({
    url: '/selfhelp/registrationActivitySession/add',
    method: 'post',
    params: query
  })
}
// 场次修改
export function registrationActivitySessionUpdate(query) {
  return fetch({
    url: '/selfhelp/registrationActivitySession/update',
    method: 'post',
    params: query
  })
}

export function regActivityEasylist(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/easylist',
    method: 'get',
    params: query
  })
}

export function getRegistrationActivityCityList() {
  return fetch({
    url: '/selfhelp/registrationActivity/cityList',
    method: 'get'
  })
}

export function regActivityAdd(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/create',
    method: 'post',
    params: query
  })
}

// 活动
export function regActivityGet(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/get',
    method: 'get',
    params: query
  })
}

export function regActivityUpdate(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/update',
    method: 'put',
    params: query
  })
}

// 活动
export function regActivityInvalid(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/invalid',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function regActivityDel(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/del',
    method: 'post',
    params: query
  })
}

// 活动黑名单
export function registrationBlacklistList(query) {
  return fetch({
    url: '/selfhelp/registrationBlacklist/list',
    method: 'get',
    params: query
  })
}

export function registrationBlacklistCreate(query) {
  return fetch({
    url: '/selfhelp/registrationBlacklist/create',
    method: 'post',
    params: query
  })
}

export function registrationBlacklistUpdate(query) {
  return fetch({
    url: '/selfhelp/registrationBlacklist/update',
    method: 'put',
    params: query
  })
}

export function registrationBlacklistDelete(query) {
  return fetch({
    url: '/selfhelp/registrationBlacklist/delete',
    method: 'post',
    params: query
  })
}

export function regActivityRecordlist(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/list',
    method: 'get',
    params: query
  })
}
export function regActivityRecordinfo(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/get',
    method: 'get',
    params: query
  })
}

// 获取活动入口图配置
export function getRegistrationActivityEntryImage() {
  return fetch({
    url: '/selfhelp/registrationActivity/entryImage',
    method: 'get'
  })
}

// 保存活动入口图配置
export function saveRegistrationActivityEntryImage(data) {
  return fetch({
    url: '/selfhelp/registrationActivity/entryImage',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取同时报名活动场次限制
export function getRegistrationActivityRegisterLimit() {
  return fetch({
    url: '/selfhelp/registrationActivity/registerLimit',
    method: 'get'
  })
}

// 保存同时报名活动场次限制
export function saveRegistrationActivityRegisterLimit(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/registerLimit',
    method: 'post',
    params: query
  })
}

// 获取自动拉黑设置
export function getRegistrationActivityAutoBlacklistSetting() {
  return fetch({
    url: '/selfhelp/registrationActivity/autoBlacklistSetting',
    method: 'get'
  })
}

// 保存自动拉黑设置
export function saveRegistrationActivityAutoBlacklistSetting(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/autoBlacklistSetting',
    method: 'post',
    params: query
  })
}

export function recordExport(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/export',
    method: 'get',
    params: query
  })
}
export function registrationRecordReissueCoupon(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/reissueCoupon',
    method: 'post',
    params: query
  })
}
export function registrationRecordRefund(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/refund',
    method: 'post',
    params: query
  })
}
// 免费活动取消报名记录
export function registrationRecordCancelFree(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/cancelFree',
    method: 'post',
    params: query
  })
}
export function registrationReview(query) {
  return fetch({
    url: '/selfhelp/registrationReview',
    method: 'put',
    params: query
  })
}

// 活动协议库
export function regAgreementList(query) {
  return fetch({
    url: '/selfhelp/registrationAgreement/list',
    method: 'get',
    params: query
  })
}

// 活动协议简易列表，用于活动新增、编辑页的协议多选项
export function regAgreementEasylist(query) {
  return fetch({
    url: '/selfhelp/registrationAgreement/easylist',
    method: 'get',
    params: query
  })
}

export function regAgreementGet(query) {
  return fetch({
    url: '/selfhelp/registrationAgreement/get',
    method: 'get',
    params: query
  })
}

export function regAgreementAdd(query) {
  return fetch({
    url: '/selfhelp/registrationAgreement/create',
    method: 'post',
    params: query
  })
}

export function regAgreementUpdate(query) {
  return fetch({
    url: '/selfhelp/registrationAgreement/update',
    method: 'put',
    params: query
  })
}

// 被活动使用时后端会拦截并返回错误提示，由拦截器统一 toast
export function regAgreementDel(query) {
  return fetch({
    url: '/selfhelp/registrationAgreement/delete',
    method: 'post',
    params: query
  })
}

// 协议文档库（协议中可点击链接指向的富文本内容）
export function regAgreementDocList(query) {
  return fetch({
    url: '/selfhelp/registrationAgreementDocument/list',
    method: 'get',
    params: query
  })
}

export function regAgreementDocEasylist(query) {
  return fetch({
    url: '/selfhelp/registrationAgreementDocument/easylist',
    method: 'get',
    params: query
  })
}

export function regAgreementDocGet(query) {
  return fetch({
    url: '/selfhelp/registrationAgreementDocument/get',
    method: 'get',
    params: query
  })
}

export function regAgreementDocAdd(query) {
  return fetch({
    url: '/selfhelp/registrationAgreementDocument/create',
    method: 'post',
    params: query
  })
}

export function regAgreementDocUpdate(query) {
  return fetch({
    url: '/selfhelp/registrationAgreementDocument/update',
    method: 'put',
    params: query
  })
}

// 被协议 links 引用时后端会拦截并返回错误提示
export function regAgreementDocDel(query) {
  return fetch({
    url: '/selfhelp/registrationAgreementDocument/delete',
    method: 'post',
    params: query
  })
}
